import { useMutation } from "react-query";
import RecipientService from "../../services/recipient-data-service/RecipientDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { IRecipientEditDTO } from "../../services/recipient-data-service/Models";
import { queryClient } from "../../services/query-client-service/QueryClientService";
import { keys } from "./Keys";

export type UseSaveRecipientParameters = {
    groupID: number,
    organizationID: number
} & BaseUseMutationParameters<IRecipientEditDTO, IRecipientEditDTO>;

export function useSaveRecipient({
    groupID,
    organizationID,
    onError,
    onSuccess
}: UseSaveRecipientParameters) {

    return useMutation<IRecipientEditDTO, RestError, IRecipientEditDTO>(
        (model) => {
            return RecipientService.saveRecipient(
                groupID,
                organizationID,
                model
            );
           
        },
        {
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, error, _item, context) => {
                queryClient.refetchQueries([keys.referenceDatas(), keys.usageLists()]);
            }
        }
    );
}
